enum TimeFrameUnit {
  HOUR_AGO = 'HOUR_AGO',
  DAY_AGO = 'DAY_AGO',
  MONTH_AGO = 'MONTH_AGO',
  YEAR_AGO = 'YEAR_AGO',
  HOUR_FROM_NOW = 'HOUR_FROM_NOW',
  DAY_FROM_NOW = 'DAY_FROM_NOW',
  MONTH_FROM_NOW = 'MONTH_FROM_NOW',
  YEAR_FROM_NOW = 'YEAR_FROM_NOW',
}

export { TimeFrameUnit };
